import * as React from 'react';

import {
    StyledChevronLeft,
    StyledChevronRight,
    StyledScrollButton
} from './styled.components';

export type ArrowButtonsProps = {
    nextSlideAriaLabel: string;
    onClickNext: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onPrevClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    previousSlideAriaLabel: string;
    isRtl: boolean;
};

export const ArrowButtons = ({
    nextSlideAriaLabel,
    onClickNext,
    onPrevClick,
    previousSlideAriaLabel,
    isRtl
}: ArrowButtonsProps): React.ReactElement => (
    <>
        <StyledScrollButton
            className="previous"
            onClick={onPrevClick}
            aria-label={previousSlideAriaLabel}
        >
            {isRtl ? (
                <StyledChevronRight aria-hidden />
            ) : (
                <StyledChevronLeft aria-hidden />
            )}
        </StyledScrollButton>
        <StyledScrollButton
            className="next"
            onClick={onClickNext}
            aria-label={nextSlideAriaLabel}
        >
            {isRtl ? (
                <StyledChevronLeft aria-hidden />
            ) : (
                <StyledChevronRight aria-hidden />
            )}
        </StyledScrollButton>
    </>
);
